import React__default from 'react';

const SelectListContext = /*#__PURE__*/React__default.createContext({
  mobileFullScreen: false,
  multiple: false,
  noWrap: false,
  onClick: undefined,
  selectedValue: undefined,
  afterOnSelect: undefined
});

export { SelectListContext as S };
//# sourceMappingURL=SelectListContext-D8hyna51.js.map
